import { render, staticRenderFns } from "./homeEmail.vue?vue&type=template&id=18408842&"
import script from "./homeEmail.vue?vue&type=script&lang=js&"
export * from "./homeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports